import { schema } from 'normalizr';

const topic = new schema.Entity('topics', {}, { idAttribute: 'id' });
const user = new schema.Entity('users', {}, { idAttribute: 'accountId' });
const expert = new schema.Entity('experts', {}, { idAttribute: 'accountId' });
const space = new schema.Entity('spaces', {}, { idAttribute: 'spaceKey' });
const question = new schema.Entity('questions', {}, { idAttribute: 'id' });
const comment = new schema.Entity('comments', {}, { idAttribute: 'id' });
const answer = new schema.Entity('answers', {}, { idAttribute: 'id' });
const vote = new schema.Entity('votes', {}, { idAttribute: 'id' });
const query = new schema.Entity('query', {}, { idAttribute: 'id' });

answer.define({
	comments: [comment],
	author: user,
	voter: vote,
	container: question,
});
question.define({
	comments: [comment],
	topics: [topic],
	space,
	author: user,
	voter: vote,
	acceptedAnswer: answer,
});
comment.define({
	author: user,
});
expert.define({
	user,
});

const questionsList = {
	questions: [question],
};
const answersList = {
	answers: [answer],
};
const topicList = {
	topics: [topic],
};
const spaceList = {
	spaces: [space],
};
const userList = {
	users: [user],
};
const expertList = {
	experts: [expert],
};

export const topicSchema = topic;
export const userSchema = user;
export const userListSchema = userList;
export const expertSchema = expert;
export const expertListSchema = expertList;
export const spaceSchema = space;
export const commentsSchema = comment;
export const answersSchema = answer;
export const answersListSchema = answersList;
export const questionSchema = question;
export const questionsListSchema = questionsList;
export const topicListSchema = topicList;
export const spaceListSchema = spaceList;
export const voteSchema = vote;
export const querySchema = query;
